const Badge = ({ label }: { label: string; color?: string }) => (
    <span className={`inline-block rounded-full px-2 py-1 text-xs font-medium text-white bg-grey-lightest`}>
        {label}
    </span>
)

export default Badge
